import { APPLICATION_SHIPPING_CODE } from 'config/constants'
import {
  Typography,
} from '@mui/material'
import './delivery-route-line.scss'

import {
  DirectionsBoat,
  Flight,
  LocalShipping,
  Train,
} from '@vedmarket/ui-kit'

const ShippingIcon = ({ code }: ApplicationShippingIconProps) => {
  const className = 'calculation-delivery-route-line__route-icon'

  switch (code) {
    case APPLICATION_SHIPPING_CODE.SEA:
      return <DirectionsBoat className={className} aria-hidden />
    case APPLICATION_SHIPPING_CODE.AUTO:
      return <LocalShipping className={className} aria-hidden />
    case APPLICATION_SHIPPING_CODE.AVIA:
      return <Flight className={className} aria-hidden />
    case APPLICATION_SHIPPING_CODE.RAILS:
      return <Train className={className} aria-hidden />
    default:
      return null
  }
}

const uniqueShippingMethods = (freights: Freight[]): ApplicationShippingCode[] => {
  const codes: ApplicationShippingCode[] = []

  freights.forEach((freight) => {
    const code = freight.shipping_method?.code as ApplicationShippingCode | undefined
    if (!code) {
      return
    }
    if (codes[codes.length - 1] !== code) {
      codes.push(code)
    }
  })

  return codes
}

const DeliveryRouteLine = ({ route }: ApplicationDeliveryRouteLineProps) => {
  if (!route?.freights?.length) {
    return <Typography component='span' variant='inherit' className='calculation-delivery-route-line'>—</Typography>
  }

  const from = route.location_from?.name
  const to = route.location_to?.name
  const methods = uniqueShippingMethods(route.freights)

  if (!from && !to) {
    return <Typography component='span' variant='inherit' className='calculation-delivery-route-line'>—</Typography>
  }

  return (
    <Typography component='span' variant='inherit' className='calculation-delivery-route-line'>
      <Typography component='span' variant='inherit' className='calculation-delivery-route-line__route-city'>{from || '—'}</Typography>
      {methods.length > 0 && (
        <span className='calculation-delivery-route-line__route-icons'>
          {methods.map((code) => (
            <ShippingIcon key={code} code={code} />
          ))}
        </span>
      )}
      <Typography component='span' variant='inherit' className='calculation-delivery-route-line__route-city'>{to || '—'}</Typography>
    </Typography>
  )
}

export default DeliveryRouteLine
